// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_wrapperTooltip__\\+NUzN.Table_wrapperTooltip__\\+NUzN {
  background-color: transparent;
  padding: 0;
  z-index: 100000;
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f {
  background-color: #fff;
  border-radius: 8px;
  left: -208px; /* Ширина вашего тултипа, чтобы он открылся влево */
  top: 0; /* Выравнивание по высоте относительно кнопки */
  transform: translateY(-55%);
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f span {
  color: var(--color-black-500, #577487);
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f button span {
  color: var(--color-black-main, #364954);
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f button:hover {
  background-color: #45dcc6;
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f button:active {
  background-color: #0c6154;
}

.Table_tooltip__Hgo1f.Table_tooltip__Hgo1f button:active span {
  color: #fff;
}

.Table_lngButton__pOHup {
  color: #678aa1;
}

.Table_lngActive__38Puy {
  color: #55bbeb;
}

.Table_inputField__6KtAn {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  width: 100%;
  min-width: 150px;
}

.Table_inputField__6KtAn .Table_placeholder__pft9O,
.Table_inputField__6KtAn input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.Table_labelAndButtonWrapper__6Y40v {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Table/index.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY,EAAE,mDAAmD;EACjE,MAAM,EAAE,+CAA+C;EACvD,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".wrapperTooltip.wrapperTooltip {\n  background-color: transparent;\n  padding: 0;\n  z-index: 100000;\n}\n\n.tooltip.tooltip {\n  background-color: #fff;\n  border-radius: 8px;\n  left: -208px; /* Ширина вашего тултипа, чтобы он открылся влево */\n  top: 0; /* Выравнивание по высоте относительно кнопки */\n  transform: translateY(-55%);\n}\n\n.tooltip.tooltip span {\n  color: var(--color-black-500, #577487);\n}\n\n.tooltip.tooltip button span {\n  color: var(--color-black-main, #364954);\n}\n\n.tooltip.tooltip button:hover {\n  background-color: #45dcc6;\n}\n\n.tooltip.tooltip button:active {\n  background-color: #0c6154;\n}\n\n.tooltip.tooltip button:active span {\n  color: #fff;\n}\n\n.lngButton {\n  color: #678aa1;\n}\n\n.lngActive {\n  color: #55bbeb;\n}\n\n.inputField {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(50% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField .placeholder,\n.inputField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.labelAndButtonWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2px;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperTooltip": `Table_wrapperTooltip__+NUzN`,
	"tooltip": `Table_tooltip__Hgo1f`,
	"lngButton": `Table_lngButton__pOHup`,
	"lngActive": `Table_lngActive__38Puy`,
	"inputField": `Table_inputField__6KtAn`,
	"placeholder": `Table_placeholder__pft9O`,
	"labelAndButtonWrapper": `Table_labelAndButtonWrapper__6Y40v`
};
export default ___CSS_LOADER_EXPORT___;
